import IndexRoutes from "./routes";

function App() {

  return <IndexRoutes />
}

export default App;
